export enum PaymentMethodEnum {
  CASH,
  BANCONTACT,
  TRANSFER,
  LATER,
}

export const translateKey = (value: string): string => {
  return "paymentMethod." + value.toLowerCase();
};

export const getPaymentMethodName = (
  paymentMethodEnum: PaymentMethodEnum
): string => {
  switch (paymentMethodEnum) {
    case PaymentMethodEnum.CASH:
      return "Cash";
    case PaymentMethodEnum.BANCONTACT:
      return "Bancontact";
    case PaymentMethodEnum.TRANSFER:
      return "Transfer";
    case PaymentMethodEnum.LATER:
      return "Later";
  }
};

export const allPaymentMethods = () => {
  return [
    PaymentMethodEnum.CASH,
    PaymentMethodEnum.BANCONTACT,
    PaymentMethodEnum.TRANSFER,
    PaymentMethodEnum.LATER,
  ];
};
